// Module
var code = "<div class=\"claim__text\"> <h4 class=\"claim__text__text sofia uppercase regular\"></h4> </div> <div class=\"claim__image image\"></div> ";
// Exports
export default code;